// removed by extract-text-webpack-plugin
module.exports = {"reportProperty":"_1z-vrAQ2uPkxJSbL9S0-rn","reportButton":"_1Elsf_rR_Z7ZFBbed8q_xf","opened":"cKeMEi2jGTmFAC_YoE2DN","reportForeign":"yRlvH55QAA9LmE6P-USeG","reportFormWrapper":"_1gWc2YGlV3TI53aq2HeDJt","mobileStyle":"xTw5EwGtOi_umMZDaoiiY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportProperty/ReportProperty.scss
// module id = 1762
// module chunks = 0